import { FC } from "react";

const EmptyValue: FC = () => <span className="italic text-gray-400">—</span>;

export default EmptyValue;
